/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiScrollspyData } from './hei-scrollspy.data';
import { IHeiScrollspyProps } from './hei-scrollspy.props.autogenerated';

export interface IHeiScrollspyViewProps extends IHeiScrollspyProps<IHeiScrollspyData> {}

/**
 *
 * HeiScrollspy component
 * @extends {React.PureComponent<IHeiScrollspyProps<IHeiScrollspyData>>}
 */
class HeiScrollspy extends React.PureComponent<IHeiScrollspyProps<IHeiScrollspyData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiScrollspy;
